module.exports = __webpack_public_path__ + "static/media/1008185.f005a5cb.png";